import { pull, sample } from 'lodash';
import categoryIcons from 'constants/category-icons';

/**
 * Get random category icon name
 * @returns {*}
 */
export default function(excludeItem) {
    let icons = Object.values(categoryIcons);

    if (excludeItem) {
        icons = pull(icons, excludeItem);
    }

    return sample(icons);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/random-category-icon.js